// This version work perfectly only issuee is image should be slected bby default
import React, { useState, useRef, useEffect } from 'react';
import './sustomselect.scss';
import zIndex from '@material-ui/core/styles/zIndex';
import { use } from 'react';
import { deliveryFormats } from '../../constants/deliveryFormats';

const CustomSelect = ({ placeholder, setDeliveryFormat, setSelectedOptions, selectedOptions, handleInputChange }) => {
    
    const [isOpen, setIsOpen] = useState(false);
    const [options,setDefaultOptions] =useState([])
    const dropdownRef = useRef(null);
   

    const handleToggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionToggle = (option) => {
        let updatedSelectedOptions;
        if (selectedOptions.includes(option.value)) {
            updatedSelectedOptions = selectedOptions.filter((val) => val !== option.value);
        } else {
            updatedSelectedOptions = [...selectedOptions, option.value];
        }
        setSelectedOptions(updatedSelectedOptions);

        // Map selected values to their corresponding labels for API usage
        const selectedLabels = options
            .filter((opt) => updatedSelectedOptions.includes(opt.value))
            .map((opt) => opt.label);

        setDeliveryFormat(selectedLabels); // Send selected labels array directly to onChange prop
        handleInputChange('deliveryFormat', selectedLabels)
    };

    const isSelected = (value) => selectedOptions.includes(value);


    useEffect(() => {
        setDefaultOptions(deliveryFormats)
    }, [deliveryFormats]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="custom-select" ref={dropdownRef}>
            <div className="select-input" style={{ borderColor: isOpen ? '#007FFF' : '#E9E9E9' }} onClick={handleToggleDropdown}>
                <div className="selected-options">
                    {selectedOptions?.length > 0 ? (
                        selectedOptions?.map((value) => {
                            const option = deliveryFormats?.find((opt) => opt.value === value);
                            return (
                                <div key={value} className="selected-option">
                                    {option.label}
                                    <svg
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleOptionToggle(option);
                                        }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                    >
                                        <path
                                            d="M8.99998 8.99998L6.00001 6.00001M6.00001 6.00001L3 3M6.00001 6.00001L9.00002 3M6.00001 6.00001L3 9.00002"
                                            stroke="#013159"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                            );
                        })
                    ) : (
                        <span className="placehsolder">{placeholder}</span>
                    )}
                </div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                >
                    <path
                        d="M13.3333 8.3335L10 11.6668L6.66667 8.3335"
                        stroke="#013159"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>
            {isOpen && (
                <div className="select-dropdown">
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className={`select-option ${isSelected(option.value) ? 'selected' : ''}`}
                            onClick={() => handleOptionToggle(option)}
                        >
                            <div className="mainssss">
                                <div className="checkboxmain">
                                    <label className="checkbox">
                                        {isSelected(option.value) ? <img src="/assets/createtask/check2.svg" alt="" srcset="" /> : <img src="/assets/createtask/check1.svg" alt="" srcset="" />}
                                        {/* <input
                                            type="checkbox"
                                            // checked={isSelected(option.value)}
                                            onClick={() => handleOptionToggle(option)}
                                        /> */}
                                        {/* <span className="checkmark"></span> */}
                                    </label>
                                    <p className="checkboxpara">{option.label}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;


// import React, { useState, useRef, useEffect } from 'react';
// import './sustomselect.scss'
// const CustomSelect = ({ placeholder, onChange }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [selectedOptions, setSelectedOptions] = useState([]);
//     const [searchQuery, setSearchQuery] = useState('');
//     const dropdownRef = useRef(null);
//     const handleToggleDropdown = () => {
//         setIsOpen(!isOpen);
//     };
//     const options = [
//         { value: '1', label: 'JPEG' },
//         { value: '2', label: 'PDF' },
//         { value: '3', label: 'TXT' },
//         { value: '4', label: 'DOC' },
//         { value: '5', label: 'DOCX' },
//         { value: '6', label: 'JPG' },
//     ];


//     return (
//         <div className="custom-select" ref={dropdownRef}>
//             <div className="select-input" style={{ borderColor: isOpen ? '#007FFF' : '#E9E9E9' }}>
//                 <div className="selected-options">
                    
//                         <div key={1} className="selected-option">
//                         JPEG
//                             <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
//                                 <path d="M8.99998 8.99998L6.00001 6.00001M6.00001 6.00001L3 3M6.00001 6.00001L9.00002 3M6.00001 6.00001L3 9.00002" stroke="#013159" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                             </svg>
//                         </div>
//                 </div>
//                 {/* <span className={`arrow ${isOpen ? 'open' : ''}`}>▼</span> */}
//                 <svg onClick={handleToggleDropdown} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//                     <path d="M13.3333 8.3335L10 11.6668L6.66667 8.3335" stroke="#013159" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                 </svg>
//             </div>
//             {isOpen && (
//                 <div className="select-dropdown">
//                     {options.map((option) => (
//                         <div
//                             key={option.value}
//                             className={`select-option  selected`}

//                         >
//                             <div className='mainssss'>
//                                 <div className="checkboxmain">
//                                     <label class="checkbox" for="yellow">
//                                         <input type="checkbox" name="color" value="yellow" id="yellow" />
//                                         <span class="checkmark"></span>
//                                     </label>
//                                     <p className="checkboxpara"> </p>
//                                 </div>
//                             </div>

//                             {option.label}
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };
// export default CustomSelect;